import { arrayIncludes } from '../utils';
export function IntegrationPlugin(client) {
    client.on('init', function () {
        var nameList = [];
        var config = client.config();
        if (!config || !config.integrations) {
            return;
        }
        config.integrations.forEach(function (integration) {
            if (!arrayIncludes(nameList, integration.name)) {
                nameList.push(integration.name);
                integration.setup(client);
                integration.tearDown && client.on('beforeDestroy', integration.tearDown);
            }
        });
    });
}
//# sourceMappingURL=integration.js.map